export default {
  header: {
    nav: {
      home: "Home",
      solutions: "Solutions",
      pricing: "Pricing",
      demo: "Demo",
      blog: "Blog",
      login: "LOGIN",
      signup: "SIGN UP"
    }
  },
  hero: {
    title: "Simplified multicloud design and deployment",
    subtitle: "Model, estimate and deploy your architectures on Azure, AWS and GCP with an intuitive interface."
  },
  features: {
    visualDesign: {
      title: "Visual Multicloud Design",
      description: "Create, model and visualize cloud architectures on Azure, AWS, GCP or hybrid with an intuitive drag-and-drop interface."
    },
    costEstimation: {
      title: "Cost Estimation & Optimization",
      description: "Estimate monthly costs in real-time and receive automatic recommendations to optimize your cloud spending."
    },
    autoDeployment: {
      title: "Automated Deployment with Azure DevOps",
      description: "Automatically generate Terraform, PowerShell or YAML scripts and deploy via CI/CD with one click."
    },
    multiClient: {
      title: "Secure Multi-Client Management",
      description: "Manage multiple organizations in secure spaces, with role and permission management."
    },
    dashboard: {
      title: "Dashboards & Real-Time Monitoring",
      description: "Analyze performance, monitor your deployments and visualize your costs with an interactive dashboard."
    },
    integration: {
      title: "Native Cloud Integration",
      description: "Connect Azure, AWS or GCP easily, synchronize your existing resources via secure API."
    }
  },
  footer: {
    copyright: "© {{year}} GenIaC. All rights reserved."
  }
};
